var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "date-picker mg mg--b-5" }, [
    _c("p", { staticClass: "text-small-bold black mg mg--b-1" }, [
      _vm._v(_vm._s(_vm.literal)),
    ]),
    _c(
      "div",
      { staticClass: "datePicker-input-wrapper" },
      [
        _c("maDatePicker", {
          attrs: {
            value: _vm.value,
            "min-date": _vm.minDate,
            inputProps: _vm.datePickerProps,
            "max-date": _vm.maxDate,
            masks: _vm.dateMask,
            popover: _vm.datePopover,
            theme: _vm.theme,
            locale: _vm.locale,
          },
          on: {
            input: _vm.handleChangeInput,
            focus: function ($event) {
              _vm.inputIsFocused = true
            },
          },
        }),
      ],
      1
    ),
    _c(
      "p",
      {
        staticClass: "errorMsg text-small red mg mg--t-1",
        class: { errorVisible: _vm.errorInput },
      },
      [_vm._v(_vm._s(_vm.$t("claim.details.errorMsgInputTxt")))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }